<template>
  <v-app>
    <v-layout row fill-height>
      <!-- LADO ESQUERDO: TEXTO E LOGO -->
      <v-flex xs12 md7 class="left-side d-flex flex-column justify-center px-12">
        <div class="logo-container">
          <div class="text-center display-4">
            <v-layout row justify-center>
              <div id="font">
                Simples
              </div>

              <div id="font" class="primary--text">
                Medic
              </div>
            </v-layout>
          </div>
        </div>
      </v-flex>

      <!-- LADO DIREITO: LOGIN -->
      <v-flex xs12 md5 class="right-side d-flex align-center justify-center px-8 custom-bg">
        <v-card outlined class="pa-6 rounded-xl login-card" max-width="400">
          <v-window v-model="step">
            <!-- Janela de Login -->
            <v-window-item :value="1">
              <v-card-title class="headline font-weight-bold justify-center">
                Acesse sua conta
              </v-card-title>

              <v-card-text>
                <v-form ref="loginForm">
                  <v-text-field
                    ref="searchLogin"
                    v-model="user.username"
                    :prepend-icon="'mdi-account'"
                    name="username"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                    type="text"
                  />
                  <v-text-field
                    v-model="user.password"
                    prepend-icon="mdi-lock"
                    name="password"
                    label="Senha"
                    :type="showPassword ? 'text' : 'password'"
                    @keyup.enter="logar()"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showPassword = !showPassword"
                  />
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn :loading="loading" dark color="primary" class="rounded-xl" @click="logar()">
                  Login
                </v-btn>
              </v-card-actions>

              <div class="text-center mt-2">
                <v-btn text small color="primary" @click="step = 2">Esqueci minha senha</v-btn>
              </div>

              <v-snackbar
                v-model="alert"
                :timeout="5000"
                :color="alertType"
                top
                right
                class="mt-4"
              >
                {{ msg }}
                <template v-slot:action="{ attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    @click="alert = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-snackbar>
            </v-window-item>

            <!-- Janela de Recuperação de Senha -->
            <v-window-item :value="2">
              <v-card-title class="headline font-weight-bold justify-center">
                Recuperar Senha
              </v-card-title>

              <v-card-text>
                <!-- Etapa 1: Informar CPF -->
                <div v-if="recoveryStep === 1">
                  <v-form ref="formCpf">
                    <v-text-field
                      v-model="cpf"
                      label="CPF"
                      prepend-icon="mdi-card-account-details"
                      v-mask="'###.###.###-##'"
                      :rules="[v => !!v || 'CPF é obrigatório', v => v.length === 14 || 'CPF inválido']"
                      @keyup.enter="buscarCelular"
                    />
                  </v-form>

                  <v-card-actions>
                    <v-btn text @click="step = 1">Voltar</v-btn>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      dark
                      @click="buscarCelular"
                      :loading="loadingCelular"
                    >
                      Continuar
                    </v-btn>
                  </v-card-actions>

                  <v-snackbar
                    v-model="alert"
                    :timeout="5000"
                    :color="alertType"
                    top
                    right
                    class="mt-4"
                  >
                    {{ msg }}
                    <template v-slot:action="{ attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        @click="alert = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-snackbar>
                </div>

                <!-- Etapa 2: Confirmar número de celular -->
                <div v-else-if="recoveryStep === 2">
                  <v-alert type="info" class="mb-4 rounded-xl">
                    Informe os 4 últimos dígitos do número exibido para receber o código de verificação.
                  </v-alert>

                  <v-form ref="formCelular">
                    <v-text-field
                      v-model="celularMasked"
                      label="Celular"
                      prepend-icon="mdi-cellphone"
                      disabled
                    />
                    <v-text-field
                      v-model="celularFinal"
                      label="Confirme os últimos dígitos"
                      prepend-icon="mdi-numeric"
                      :rules="[v => !!v || 'Dígitos são obrigatórios', v => v === celularFinalCorreto || 'Dígitos incorretos']"
                      @keyup.enter="enviarCodigo"
                    />
                  </v-form>

                  <v-card-actions>
                    <v-btn text @click="recoveryStep = 1">Voltar</v-btn>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      :disabled="!celularFinal || celularFinal !== celularFinalCorreto"
                      @click="enviarCodigo"
                      :loading="loadingEnvio"
                    >
                      Enviar Código
                    </v-btn>
                  </v-card-actions>
                </div>

                <!-- Etapa 3: Inserir código e nova senha -->
                <div v-else-if="recoveryStep === 3">

                  <v-alert v-if="codigoValidado && alert" type="success" class="mb-4 rounded-xl">
                    Código validado com sucesso! Agora defina sua nova senha.
                  </v-alert>

                  <v-alert v-if="codigoExpiraEm > 0" type="info" class="mb-4 rounded-xl">
                    O código expira em {{ Math.floor(codigoExpiraEm / 60) }}:{{ (codigoExpiraEm % 60).toString().padStart(2, '0') }}
                  </v-alert>

                  <v-form ref="formCodigo">
                    <v-text-field
                      v-model="codigo"
                      v-mask="'######'"
                      label="Código de Verificação"
                      prepend-icon="mdi-lock-reset"
                      :rules="[v => !!v || 'Código é obrigatório']"
                      :disabled="codigoValidado"
                    />

                    <template v-if="codigoValidado">
                      <v-text-field
                        v-model="novaSenha"
                        @input="calcularForcaSenha"
                        label="Nova Senha"
                        prepend-icon="mdi-lock"
                        :type="mostrarSenha ? 'text' : 'password'"
                        :append-icon="mostrarSenha ? 'mdi-eye-off' : 'mdi-eye'"
                        @click:append="mostrarSenha = !mostrarSenha"
                      />

                      <v-progress-linear
                        :value="forcaSenha * 25"
                        :color="
                          forcaSenha < 2 ? 'red' :
                          forcaSenha < 3 ? 'orange' :
                          forcaSenha < 4 ? 'yellow' : 'green'
                        "
                        height="5"
                        class="mb-2"
                      ></v-progress-linear>
                      <!-- <div class="text-caption">
                        Força da senha:
                        {{
                          forcaSenha < 2 ? 'Fraca' :
                          forcaSenha < 3 ? 'Moderada' :
                          forcaSenha < 4 ? 'Forte' : 'Muito forte'
                        }}
                      </div> -->

                      <v-text-field
                        v-model="confirmarSenha"
                        label="Confirmar Nova Senha"
                        prepend-icon="mdi-lock-check"
                        :type="mostrarSenha ? 'text' : 'password'"
                        :rules="[v => !!v || 'Confirmação é obrigatória', v => v === novaSenha || 'As senhas não coincidem']"
                      />
                       <!-- Lista de requisitos -->
    <div class="senha-requirements mt-3">
      <div v-for="(req, index) in requisitosSenha" :key="index" class="d-flex align-center mb-1">
        <v-icon :color="req.valid ? 'success' : 'error'" small>
          {{ req.valid ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
        <span class="ml-2" :class="{ 'success--text': req.valid, 'error--text': !req.valid }">
          {{ req.text }}
        </span>
      </div>
    </div>

    <!-- Feedback quando todos os requisitos são atendidos -->
    <v-alert v-if="todosRequisitosAtendidos" outlined type="info" dense class="mt-2">
      Senha forte criada com sucesso!
    </v-alert>
                    </template>
                  </v-form>

                  <div class="text-center mt-2">
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="enviarCodigo"
                      :disabled="tempoReenvio > 0"
                    >
                      Reenviar código {{ tempoReenvio > 0 ? `(${tempoReenvio}s)` : '' }}
                    </v-btn>
                  </div>

                  <v-card-actions>
                    <v-btn text @click="recoveryStep = 2">Voltar</v-btn>
                    <v-spacer />
                    <v-btn
                      v-if="!codigoValidado"
                      color="primary"
                      dark
                      @click="validarCodigo"
                      :loading="loadingValidacao"
                    >
                      Validar Código
                    </v-btn>
                    <v-btn
                      v-else
                      color="success"
                      dark
                      @click="redefinirSenha"
                      :loading="loadingRedefinicao"
                      :disabled="!novaSenha || novaSenha !== confirmarSenha || forcaSenha < 2"
                    >
                      Redefinir Senha
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card-text>
            </v-window-item>
          </v-window>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import Cookies from 'js-cookie'
import commonUserService from '../services/commonUser.service'
import usuarioService from '../services/usuario.service'
import { mask } from 'vue-the-mask'

var sha1 = require('sha1')

export default {
  name: 'Login',

  directives: {
    mask
  },
  data: () => ({
    // Login
    user: {
      username: '',
      password: ''
    },
    loading: false,
    alert: false,
    alertType: 'error',
    msg: '',
    showPassword: false,

    // Recuperação de senha
    step: 1, // 1 = login, 2 = recuperação
    recoveryStep: 1, // 1 = CPF, 2 = celular, 3 = código
    cpf: '',
    celular: '',
    celularMasked: '',
    celularFinal: '',
    celularFinalCorreto: '',
    celularCompleto: '',
    codigo: '',
    idUsuario: null,
    cpfMask: false,
    codigoValidado: false,
    novaSenha: '',
    confirmarSenha: '',
    mostrarSenha: false,
    codigoEnviadoPor: '', // 'sms' ou 'whatsapp'
    tempoReenvio: 0,
    timerReenvio: null,
    codigoExpiraEm: 0,
    codigoTimer: null,
    forcaSenha: 0,

    // Loadings
    loadingCelular: false,
    loadingEnvio: false,
    loadingValidacao: false,
    loadingRedefinicao: false,
    requisitosSenha: [
      { text: 'Mínimo 8 caracteres', valid: false },
      { text: 'Pelo menos uma letra maiúscula', valid: false },
      { text: 'Pelo menos um número', valid: false },
      { text: 'Pelo menos um caractere especial', valid: false }
    ],
    todosRequisitosAtendidos: false,

    // Regras
    regrasSenha: [
      v => !!v || 'Senha é obrigatória',
      v => (v && v.length >= 8) || 'Senha deve ter no mínimo 8 caracteres',
      v => /[A-Z]/.test(v) || 'Deve conter pelo menos uma letra maiúscula',
      v => /[0-9]/.test(v) || 'Deve conter pelo menos um número',
      v => /[^A-Za-z0-9]/.test(v) || 'Deve conter pelo menos um caractere especial'
    ]
  }),

  mounted () {
    this.isPainel()
    this.$refs.searchLogin && this.$refs.searchLogin.focus && this.$refs.searchLogin.focus()
  },

  beforeDestroy () {
    clearInterval(this.timerReenvio)
    clearInterval(this.codigoTimer)
  },

  methods: {
    validarSenha () {
      const senha = this.novaSenha

      // Valida cada requisito
      this.requisitosSenha[0].valid = senha && senha.length >= 8
      this.requisitosSenha[1].valid = /[A-Z]/.test(senha)
      this.requisitosSenha[2].valid = /[0-9]/.test(senha)
      this.requisitosSenha[3].valid = /[^A-Za-z0-9]/.test(senha)

      // Verifica se todos os requisitos foram atendidos
      this.todosRequisitosAtendidos = this.requisitosSenha.every(req => req.valid)

      // Atualiza força da senha (opcional)
      this.forcaSenha = this.requisitosSenha.filter(req => req.valid).length
    },
    showAlert (message, type = 'error') {
      this.msg = message
      this.alertType = type
      this.alert = true
      setTimeout(() => {
        this.alert = false
      }, 5000)
    },

    isPainel () {
      if (this.$store.getters.usuario.senhaPainel && this.$store.getters.usuario.loginPainel) {
        this.user.username = this.$store.getters.usuario.loginPainel
        this.user.password = this.$store.getters.usuario.senhaPainel
        this.logar()
      }
    },

    unmask (str) {
      return str.replace(/[^\d]/g, '')
    },

    async buscarCelular () {
      if (!this.$refs.formCpf.validate()) return

      this.loadingCelular = true
      try {
        const respCpf = await commonUserService.usuario.buscarIdPorCPF(this.unmask(this.cpf))

        if (respCpf.status == 200 && respCpf.data.usuario != 'false') {
          this.idUsuario = respCpf.data.usuario.id

          const response = await usuarioService.buscarTelefonePorCPF(this.unmask(this.cpf))

          if (response.data.status === 'ok' && response.data.celular) {
            this.celular = response.data.celular
            this.celularMasked = `(${response.data.celular.substring(0, 2)}) ${response.data.celular.substring(2, 7)}-XXXX`
            this.celularFinalCorreto = response.data.celular.substring(7)
            this.celularCompleto = `(${response.data.celular.substring(0, 2)}) ${response.data.celular.substring(2, 7)}-${response.data.celular.substring(7)}`
            this.recoveryStep = 2
          } else {
            this.showAlert('CPF não encontrado ou sem celular cadastrado')
          }
        } else {
          this.showAlert('CPF não encontrado')
        }
      } catch (error) {
        this.showAlert((error.response && error.response.data && error.response.data.message) || error.message || 'CPF não encontrado ou sem celular cadastrado')
      } finally {
        this.loadingCelular = false
      }
    },

    async enviarCodigo () {
      if (!this.$refs.formCelular.validate()) return
      if (this.celularFinal !== this.celularFinalCorreto) {
        this.showAlert('Dígitos incorretos')
        return
      }

      this.loadingEnvio = true
      try {
        const response = await usuarioService.validarWatsApp(this.unmask(this.celular))
        if (response.data.status === 'Recebido') {
          this.codigoEnviadoPor = 'whatsapp'
          this.recoveryStep = 3
          this.codigo = ''
          this.iniciarTemporizadorReenvio()
          this.iniciarTemporizadorCodigo()
        }
      } catch (error) {
        this.showAlert((error.response && error.response.data && error.response.data.message) || 'Falha ao enviar código por SMS')
      } finally {
        this.loadingEnvio = false
      }
      this.alert = true
    },

    iniciarTemporizadorReenvio () {
      this.tempoReenvio = 30
      clearInterval(this.timerReenvio)
      this.timerReenvio = setInterval(() => {
        if (this.tempoReenvio > 0) {
          this.tempoReenvio--
        } else {
          clearInterval(this.timerReenvio)
        }
      }, 1000)
    },

    iniciarTemporizadorCodigo () {
      this.codigoExpiraEm = 300 // 5 minutos em segundos
      clearInterval(this.codigoTimer)
      this.codigoTimer = setInterval(() => {
        if (this.codigoExpiraEm > 0) {
          this.codigoExpiraEm--
        } else {
          clearInterval(this.codigoTimer)
          this.showAlert('O código expirou. Por favor, solicite um novo.')
        }
      }, 1000)
    },

    async validarCodigo () {
      if (!this.codigo || this.codigo.length !== 6) {
        this.showAlert('Por favor, insira um código válido de 6 dígitos')
        return
      }

      this.loadingValidacao = true
      try {
        const response = await usuarioService.validarCodigo(this.codigo, this.unmask(this.celular))

        if (response.data.status === 'ok') {
          this.codigoValidado = true
          this.showAlert('Código validado com sucesso! Agora você pode definir uma nova senha.', 'success')
        } else {
          throw new Error('Código inválido')
        }
      } catch (error) {
        this.showAlert((error && error.response && error.response.data && error.response.data.message) ||
                   error.message ||
                   'Código inválido ou expirado')
      } finally {
        this.loadingValidacao = false
      }
    },

    async redefinirSenha () {
      if (this.novaSenha !== this.confirmarSenha) {
        this.showAlert('As senhas não coincidem')
        return
      }

      this.loadingRedefinicao = true
      try {
        const response = await commonUserService.usuario.redefinirSenha({
          id: this.idUsuario,
          password: sha1(this.novaSenha)
        })

        if (response.status === 200) {
          this.showAlert('Senha redefinida com sucesso!', 'success')

          setTimeout(() => {
            this.step = 1
            this.resetRecuperacao()
          }, 2000)
        } else {
          throw new Error('Falha ao redefinir senha')
        }
      } catch (error) {
        this.showAlert((error && error.response && error.response.data && error.response.data.message) ||
                   error.message ||
                   'Falha ao redefinir senha')
      } finally {
        this.loadingRedefinicao = false
      }
    },

    calcularForcaSenha () {
      let score = 0
      if (!this.novaSenha) {
        this.forcaSenha = 0
        return
      }

      // Pontua por tamanho
      score += Math.min(4, Math.floor(this.novaSenha.length / 3))

      // Pontua por diversidade de caracteres
      if (/[A-Z]/.test(this.novaSenha)) score += 1
      if (/[0-9]/.test(this.novaSenha)) score += 1
      if (/[^A-Za-z0-9]/.test(this.novaSenha)) score += 1

      this.forcaSenha = Math.min(4, score)
      this.validarSenha()
    },

    resetRecuperacao () {
      this.recoveryStep = 1
      this.cpf = ''
      this.celular = ''
      this.celularMasked = ''
      this.celularFinal = ''
      this.celularFinalCorreto = ''
      this.celularCompleto = ''
      this.codigo = ''
      this.novaSenha = ''
      this.confirmarSenha = ''
      this.codigoEnviadoPor = ''
      this.codigoValidado = false
      this.forcaSenha = 0
      clearInterval(this.timerReenvio)
      clearInterval(this.codigoTimer)
      this.tempoReenvio = 0
      this.codigoExpiraEm = 0

      this.todosRequisitosAtendidos = false
    },

    logar () {
      this.loading = true
      this.alert = false

      if (this.loginTimeout) {
        clearTimeout(this.loginTimeout)
      }

      this.loginTimeout = setTimeout(() => {
        this.loading = false
        this.showAlert('Tempo excedido - servidor não respondeu')
      }, 15000)

      if (this.user.username && this.user.password) {
        this.$store.dispatch('updateProntuario', [{ idAtendimento: '', conteudoLaudo: '', conteudoProntuario: '' }])
        this.user.username = this.unmask(this.user.username)
        this.$store.dispatch('Login', this.user)
          .then(r => {
            console.log(r)
            clearTimeout(this.loginTimeout)
            this.loading = false

            if (r.perfil && r.perfil === 'nutricionista') {
              return this.$router.push('/homeNutricionista')
            }

            const redirectMap = {
              1: '/dashboardEmpresa',
              2: '/homeRecepcionista',
              3: '/homeAtendente',
              4: '/homeMedico',
              5: '/dashboardUnidade',
              6: () => {
                this.$store.dispatch('SetLoginPainel', this.user.username)
                this.$store.dispatch('SetSenhaPainel', this.user.password)
                return '/HomePainel'
              },
              7: '/homeApoio',
              8: '/homeMedico',
              10: '/homeAdministradorDev',
              11: '/homeRecepcionistaEspecial',
              12: '/posAtendimento',
              13: '/homeNutricionista'
            }

            const redirectTo = redirectMap[r.tipo]
            if (typeof redirectTo === 'function') {
              this.$router.push(redirectTo())
            } else if (redirectTo) {
              this.$router.push(redirectTo)
            } else {
              this.showAlert('Tipo de usuário não reconhecido')
            }
          })
          .catch(error => {
            clearTimeout(this.loginTimeout)
            this.loading = false
            this.showAlert(error.message || error || 'Erro desconhecido ao fazer login')
          })
      } else {
        clearTimeout(this.loginTimeout)
        this.loading = false
        this.showAlert('Por favor, preencha todos os campos')
      }
    }
  },

  props: {
    source: String
  }
}
</script>

<style scoped>
.custom-bg {
  background-color: #99CC99;
}

.left-side {
  background-color: #0d1a2e;
  color: #ffffff;
}

.logo-container {
  text-align: center;
}

.responsive-logo {
  max-width: 100%;
  height: auto;
  max-height: 150px;
}

.right-side {
  background-color: #ffffff;
}

.login-card {
  width: 100%;
  max-width: 400px;
}

.v-card__actions {
  padding: 8px 0;
}

.v-alert {
  border-radius: 12px !important;
}
</style>
